:host {
  display: block;
  cursor: pointer;
  border: 0;
  z-index: 100;

  font-size: 18px;
  line-height: 1.5;
  color: var(--sdx-color-gray-tint-3);
  overflow-wrap: break-word;

  .wrapper {
    padding: 4px 16px 4px 0;
  }
}

:host(:last-child) {
  .wrapper {
    border-color: transparent;
    padding-bottom: 0;
  }
}

:host(:hover) {
  background-color: var(--sdx-color-aluminum-tint-2);
}

:host(.focus) {
  background-color: var(--sdx-color-aluminum-tint-2);
}

:host(.s2) {
  .wrapper {
    padding: var(--sdx-baseline) var(--sdx-baseline-3);
  }
}
